/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum ProductStatus {
  /**
   * Aktuálny
   */
  STATUS_ACTIVE = "STATUS_ACTIVE",
  /**
   * Blokovaný
   */
  STATUS_BLOCKED = "STATUS_BLOCKED",
  /**
   * Zmazaný
   */
  STATUS_DELETED = "STATUS_DELETED",
  /**
   * Expirovaný
   */
  STATUS_EXPIRED = "STATUS_EXPIRED",
  /**
   * Pozastavený
   */
  STATUS_INACTIVE = "STATUS_INACTIVE",
}
export enum MyProductsStatusType {
  ACTIVE = "ACTIVE",
  ALL = "ALL",
  ALL_WITHOUT_DELETED = "ALL_WITHOUT_DELETED",
  BLOCKED = "BLOCKED",
  COULD_UPDATE = "COULD_UPDATE",
  DELETED = "DELETED",
  EXPIRED = "EXPIRED",
  NOT_ACTIVE = "NOT_ACTIVE",
  NOT_REPLIED = "NOT_REPLIED",
  STOPPED_OR_RESERVED = "STOPPED_OR_RESERVED",
}
export enum MyBazaarType {
  SELLING = "SELLING",
  SHOPPING = "SHOPPING",
  WISHLIST = "WISHLIST",
}